export class UnSelected {
    static UnSelectedText = 0;

    value: number;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}